import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import MUploadFile from "@app/components/MUploadFile";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import { cleanFileName } from "./fileUploadAreaExe";
import { procesarRPTOut } from "./helpers";

export const parseRptFileGenie = (content) => {
  const lines = content.split("\n");
  let data: any = {};
  let detectorFound = false;
  let dateCountingFound = false;
  let timeCountingFound = false;
  let dateCalibrationFound = false;

  lines.forEach((line) => {
    if (line.includes("Detector") && !detectorFound) {
      data.detector = line.split(":")[1].trim();
      detectorFound = true;
    }
    if (line.includes("Fecha de colecci") && !dateCountingFound) {
      data.date_counting = `${line.split(":")[1].trim()}:${line
        .split(":")[2]
        .trim()}:${line.split(":")[3].trim()}`;
      dateCountingFound = true;
    }
    if (line.includes("Tiempo vivo") && !timeCountingFound) {
      data.time_count = parseInt(line.split(":")[1].trim());
      timeCountingFound = true;
    }
    if (
      (line.includes("Fecha de calibraci�n Eficiencia/Energ�a") ||
        line.includes("Fecha de calibraci¢n Eficiencia/Energía")) &&
      !dateCalibrationFound
    ) {
      data.date_energy = line.split(":")[1].trim();
    }
    if (line.includes("Nombre de geometr"))
      data.geometry = line.split(":")[1].trim();
    if (line.includes("Certificado Fuente Cal."))
      data.certification = line.split(":")[1].trim();
    if (line.includes("FONDO")) {
      const pathParts = line
        .split(":")[2]
        .trim()
        .split("/")
        .filter((part) => part !== "");

      data.fondo = pathParts[pathParts.length - 1];
    }
    if (line.includes("Libreria")) {
      const pathParts = line
        .split(":")[2]
        .trim()
        .split("/")
        .filter((part) => part !== "");

      data.library = pathParts[pathParts.length - 1];
    }
  });
  return data;
};

const FileUploadGenie = () => {
  const { setValue, getValues, watch } = useFormContext();

  const { currentCalculation, importFileFromRoute } = useAnalysis();

  const parseRptFile = (content) => {
    const data = parseRptFileGenie(content);
    const dataIsotopes = procesarRPTOut(content);

    setValue("calculation_equipment_file", data.detector);
    setValue("calculation_date_countig_file", data.date_counting);
    setValue("calculation_detector", data.geometry);
    setValue("calibration_source_certificate", data.certification);
    setValue("calculation_time_count", data.time_count);
    setValue("calibration_efficiency_date", data.date_energy);
    setValue("calculation_background", data.fondo);
    setValue("calculation_library", data.library);
    setValue("dataIsotopes", dataIsotopes);
  };

  const handleDownload = async () => {
    await importFileFromRoute(
      getValues("source_app_calculation_info_file"),
      "DOWNLOAD"
    );
  };
  const isDisabled = useMemo(
    () => Boolean(watch("idResultPreload")),
    [watch("idResultPreload")]
  );

  return (
    <MUploadFile
      key={`${getValues("source_app_calculation_info_file")}_genie`}
      acceptFile=".rpt"
      onFileChange={parseRptFile}
      name="source_app_calculation_info_file_genie"
      preloadNameFile={cleanFileName(
        getValues("source_app_calculation_info_file")
      )}
      validation={
        currentCalculation.id ? {} : { required: "Este campo es requerido" }
      }
      downloadFile={currentCalculation.id ? handleDownload : undefined}
      disabled={isDisabled}
    />
  );
};
export default FileUploadGenie;
